<template>
    <div class="sidebar-wrapper" data-simplebar="true">
        <div class="sidebar-header">
            <div>
                <img :src="logo" class="logo-icon" alt="logo icon">
            </div>
            <div>
                <h4 class="logo-text">{{ appName }}</h4>
            </div>
            <div class="toggle-icon ms-auto" @click="toggleSidebar"><i class='bx bx-arrow-back'></i>
            </div>
        </div>
        <!--navigation-->
        <div class="sidebar-menu">
            <!-- {{ menus }} -->
            <ul ref="metismenu" class="metismenu" id="menu" v-if="menus.length > 0">
                <li v-for="menu in menus" :key="menu.path" :class="{'mm-active': menuStore.isActive(route, menu.path)}">
                    <router-link :to="menu.path" :key="menu.path">
                        <div class="parent-icon">
                            <i :class="['bx',`bx-${menu.icon}`]"></i>
                        </div>
                        <div class="menu-title">{{ menu.headline }}</div>
                    </router-link>
                </li>
            </ul>
        </div>
        <!--end navigation-->
    </div>
</template>

<script setup>
import MetisMenu from 'metismenu'
import { computed, onBeforeUnmount, onMounted, ref, watch, watchEffect } from 'vue';
import { appConf } from '../configs/appConfig';
import { useRoute } from 'vue-router';
import { useMenusStore } from '@/stores/sidebar';

const logo = computed(() => appConf.logo);
const appName = computed(() => appConf.name);

const metismenu = ref(null);
const menuStore = useMenusStore();
const route = useRoute();
const menus = ref(menuStore.filteredMenus);
let metisMenuInstance = null;

const wrapper = ref(null);
const sidebarWrapper = ref(null);

const toggleSidebar = (e) => {
    e.preventDefault();
    const wrapperE1 = document.querySelector('.wrapper');
    const sidebarWrapperE1 = document.querySelector('.sidebar-wrapper');

    if (!wrapperE1 || !sidebarWrapper) return;

    if (wrapperE1.classList.contains('toggled')) {
        wrapperE1.classList.remove('toggled');
        sidebarWrapperE1.removeEventListener('mouseenter', addSidebarHovered);
        sidebarWrapperE1.removeEventListener('mouseleave', removeSidebarHovered);
    } else {
        wrapperE1.classList.add('toggled');
        sidebarWrapperE1.addEventListener('mouseenter', addSidebarHovered);
        sidebarWrapperE1.addEventListener('mouseleave', removeSidebarHovered);
    }
}

// Fonctions pour gérer le hover sur la sidebar
const addSidebarHovered = () => {
    document.querySelector('.wrapper')?.classList.add('sidebar-hovered');
};

const removeSidebarHovered = () => {
    document.querySelector('.wrapper')?.classList.remove('sidebar-hovered');
};

onMounted(() => {
    metisMenuInstance = new MetisMenu(metismenu.value);
    wrapper.value = document.querySelector('.wrapper');
    sidebarWrapper.value = document.querySelector('.sidebar-wrapper');
});

watchEffect(() => {
    const display = route.meta.display;
    if (display !== menuStore.getDisplayMenu) {
        menuStore.setDisplayMenu(display);
    }
});

watch(() => menuStore.filteredMenus, (newMenus) => {
    menus.value = newMenus;
}, {immediate: true, deep: true})

onBeforeUnmount(() => {
    if (metisMenuInstance && typeof metisMenuInstance.dispose === 'function') {
        metisMenuInstance?.dispose();
    }
    sidebarWrapper.value?.removeEventListener('mouseenter', addSidebarHovered);
    sidebarWrapper.value?.removeEventListener('mouseleave', removeSidebarHovered);
})
</script>